import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import Sticky from 'react-stickynode';
import clsx from 'clsx';

import useStyles from './styles';
import { useIsDesktop } from 'components/utilities';

const TopBar = ({ title, actions, stickyBar, oneLine = false }) => {
	const classes = useStyles();

	const isDesktop = useIsDesktop();
	const variant = isDesktop ? 'h2' : 'h5';
	const py = isDesktop ? 3 : 2;

	return (
		<>
			<Box className={classes.root}>
				<Box py={py} className={clsx(!isDesktop && oneLine && classes.oneLine)}>
					{actions}
					<Box pt={oneLine ? 0 : 2}>
						<Typography variant={variant} align="center">
							{title}
						</Typography>
					</Box>
				</Box>
			</Box>
			{stickyBar && isDesktop ? (
				<Sticky enabled={true} top={0} innerClass={classes.stickyBar}>
					{stickyBar}
				</Sticky>
			) : (
				stickyBar
			)}
		</>
	);
};

TopBar.propTypes = {
	title: PropTypes.string,
	oneLine: PropTypes.bool,
	stickyBar: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node),
	]),
	actions: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node),
	]),
};

export default TopBar;
